import { GridColumnProps } from "@roc/ui";
import { noOpComparator } from '@roc/ui/utils';
import { usdAmount } from 'libs/ui/src/lib/components/borrowerBaseballCard/utils';

const idCellStyle = { left: 0, lineHeight: '35px', overflow: 'visible' };
const wrappedCellStyle = { lineHeight: '18px' };
const centeredCellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };

export const CLOSING_LOANS_COLUMNS: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellClass: 'badge-overflow-cell',
    cellStyle: idCellStyle,
    minWidth: 100,
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Sub Type',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 80,
  },
  {
    field: 'loanAmount',
    headerName: 'Loan Amount',
    valueFormatter: usdAmount,
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    minWidth: 105,
  },
  {
    field: 'initialAmount',
    headerName: 'Initial Loan Amount',
    valueFormatter: usdAmount,
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    minWidth: 105,
  },
  {
    field: 'attorney',
    headerName: 'Attorney',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 95,
  },
  {
    field: 'originator',
    headerName: 'Originator',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
  },
  {
    field: 'insurance',
    headerName: 'Insurance',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 80,
  },
  {
    field: 'hudStatus',
    headerName: 'HUD',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 50,
  },
  {
    field: 'loanDocs',
    headerName: 'Loan Docs',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 70,
  },
  {
    field: 'titleDocuments',
    headerName: 'Title Docs',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 75,
  },
  {
    field: 'achConsentFormStatus',
    headerName: 'ACH',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 65,
  },
  {
    field: 'exceptionsAndClosingConditions',
    headerName: 'Closing Conditions',
    cellRenderer: 'exceptionsAndClosingConditionsCellRender',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 105,
  },
  {
    field: 'entityDocuments',
    headerName: 'Entity Docs',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 75,
  },
  {
    field: 'loanApproved',
    headerName: 'Loan Approved',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 95,
  },
  {
    field: 'wireRequested',
    headerName: 'Wire Requested',
    cellRenderer: 'wireRequestedCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 105,
  },
  {
    field: 'expectedClosingDateConfirmed',
    headerName: 'Closing Confirmed',
    cellRenderer: 'closingConfirmCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 105,
  },
];
